import {useEffect, useState} from "react";

const getIsMobile = () => window.innerWidth <= 500;
const getIsMenuBreakpoint = () => window.innerWidth <= 768;

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(getIsMobile());

    useEffect(() => {
        const onResize = () => {
            setIsMobile(getIsMobile());
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    return isMobile;
}

export function useIsMenuBreakpoint() {
    const [isMenuBreakpoint, setIsMenuBreakpoint] = useState(getIsMenuBreakpoint());

    useEffect(() => {
        const onResize = () => {
            setIsMenuBreakpoint(getIsMenuBreakpoint());
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    return isMenuBreakpoint;
}